module.exports = __webpack_public_path__ + "img/luyuanRewardStarFx.23458f03.png";